import { render } from 'preact';
import './styles.css';
import { usePath } from './lib/router.js';
import { LoginPage } from './pages/LoginPage.js';
import { RoomPage } from './pages/RoomPage.js';
import { EpisodePage } from './pages/EpisodePage.js';
import { GuestPage } from './pages/GuestPage.js';
import { ObsOverlayPage } from './pages/ObsOverlayPage.js';
import { ObsSpeakerPage } from './pages/ObsSpeakerPage.js';

function App() {
  const path = usePath();

  const episodeMatch = path.match(/^\/episodes\/(\d+)$/);
  if (episodeMatch) return <EpisodePage episodeId={Number(episodeMatch[1])} />;

  const guestMatch = path.match(/^\/g\/([^/]+)$/);
  if (guestMatch) return <GuestPage token={decodeURIComponent(guestMatch[1])} />;

  const overlayMatch = path.match(/^\/obs\/overlay\/(\d+)$/);
  if (overlayMatch) return <ObsOverlayPage episodeId={Number(overlayMatch[1])} />;

  const speakerMatch = path.match(/^\/obs\/speaker\/(\d+)\/([^/]+)$/);
  if (speakerMatch) {
    return <ObsSpeakerPage episodeId={Number(speakerMatch[1])} identity={decodeURIComponent(speakerMatch[2])} />;
  }

  if (path === '/login' || path === '/register') return <LoginPage />;
  return <RoomPage />;
}

render(<App />, document.getElementById('root')!);
